export function redirectToPath(path: string): void {
  window.location.href = path;
}
